export default {
  Rules: {
    DEFAULT_DESC: 'This rule is added automatically when no other {{type}} rule has "Apply to all transactions" set.',
    SOME_BROKEN_RULE: 'Some rules have missing account code assignments',
    BROKEN_RULE: '',
    NO_MATCH: 'No rules matching your search were found',
    ADD_NEW: 'Add new',
    Missing: {
      TITLE: 'Not found',
      BODY: "Sorry, we can't find that rule. If you clicked on a link that was broken, please let us know using the chat widget in the right-hand corner",
    },
    Table: {
      EDIT: 'Edit rule',
      ARCHIVE: 'Archive rule',
      CLONE: 'Duplicate rule',
      Headers: {
        NAME: 'Rule Name',
        TYPE: 'Type',
        RECHARGED_ENTITIES: 'Recharged Entities',
        RECHARGING_ENTITIES: 'Recharging Entities',
      },
      Empty: {
        COST_MESSAGE: 'You haven\'t created any expense rules for this entity yet',
        SALES_MESSAGE: 'You haven\'t created any revenue rules for this entity yet',
        NEW: 'Create one now',
        none: "You haven't created any Mayday rules yet.",
        none_description: 'You can use Mayday rules to generate recharges where there is no source transaction in Xero, for instance a fixed management charge.',
      },
      Archive: {
        TITLE: 'Archive {{name}}',
        BODY: 'Are you sure you wish to archive {{name}}?',
      },
      SALES: 'Revenue Rules',
      COST: 'Expense Rules',
      BALANCE_SHEET: 'Balance Sheet Rules',
      MAYDAY: 'Mayday Rules',
    },
    Types: {
      none: 'Don\'t recharge (expenses)',
      cost: 'At Cost',
      costPlus: 'Cost plus',
      sales: 'Percentage of Revenue',
      noneSales: 'Don\'t recharge (revenue)',
      value: 'At Value',
      noneBalance: 'Don\'t recharge (balance sheet)',
      fixed: 'Mayday',
    },
    BooleanConditions: {
      ALL: 'all',
      ANY: 'any',
    },
    MatchTypes: {
      nominalCode: 'Account code',
      trackingCategory: 'Tracking category',
      contact: 'Contact',
      linkedContact: 'Assigned to',
      description: 'Line item description',
      narration: 'Reference',
    },
    MatchConditions: {
      oneOf: 'one of',
      notOneOf: 'not one of',
      contains: 'contains',
      doesNotContain: 'does not contain',
    },
  },
  CreateRule: {
    _HEADING: 'New Recharge Rule',
    REVENUE_HEADING: 'New Revenue Recharge Rule',
    EXPENSE_HEADING: 'New Expense Recharge Rule',
    BALANCE_SHEET_HEADING: 'New Balance Sheet Rule',
    NONE_HEADING: 'New Mayday Rule',
    EDITING: 'Editing: {{name}}',
    SAVE_ERROR: 'There was an error saving your rule, please check the details you\'ve entered and try again',
    REVENUE_CREATING_ORG: 'Which entity generated the revenue?',
    EXPENSE_CREATING_ORG: 'Which entity incurred the expense?',
    RULE_TYPE: 'Which rule should be applied?',
    NAME: 'Give this rule a name',
    SAVE: 'Save rule',
    NOT_LOADED_DATA: 'This entity has not completed syncing data with Xero yet, so some properties may be unavailable',
    OPTIONAL: '(optional)',
    Apportionment: {
      HEADING: 'Which entities should be charged?',
    },
    Royalties: {
      HEADING: 'Which entities should receive revenue from this rule?',
      ROYALTY: '% of Revenue',
      POST_TO: 'Assign revenue to',
      ADD_ENTITY: '+ Add another entity',
    },
    Cost: {
      TRANSACTIONS_1: 'Apply this rule to expense transactions from',
      TRANSACTIONS_2: 'which meet',
      TRANSACTIONS_3: 'of the following',
    },
    CostPlus: {
      EXPENSE_POSTING: 'Which account code should revenue from this rule be assigned?',
      MARKUP: 'What markup should be applied to costs?',
    },
    Sales: {
      REV_ENTITY: 'Which entity generated the revenue?',
      RECHARGE_PERC: 'What percentage of the revenue should be recharged?',
      TRANSACTIONS_1: 'Apply this rule to revenue transactions from',
      TRANSACTIONS_2: 'which meet',
      TRANSACTIONS_3: 'of the following',
      INCOME_CODE: 'Which account code under {{entity}} should revenue from this rule be assigned?',
      Cost: {
        TITLE: 'What should happen in {{entity}} to the expense from this rule?',
        NET: 'Net it off against the relevant revenue account codes and tracking categories',
        CODE: 'Post it as an expense to:',
      },
    },
    BalanceSheet: {
      TRANSACTIONS_1: 'Apply this rule to balance sheet transactions from',
      TRANSACTIONS_2: 'which meet',
      TRANSACTIONS_3: 'of the following',
    },
    Mayday: {
      AMOUNT: 'How much should be recharged?',
      APPLICATION: 'Apply the amount from step 1',
      APPLICATION_TOTAL: 'As total and split by percentage',
      APPLICATION_UNIT: 'As the amount per apportionment unit',
    },
    TransactionSource: {
      TITLE: 'Which source contains these transactions?',
    },
    TransactionMatcher: {
      Cost: {
        MATCHING: 'Which expense transactions should be recharged?',
        UNMATCHED: 'Make this the default expense rule',
        SPECIFIC: 'Recharge specific expense transactions',
        UNMATCHED_DESC: 'Only expense transactions which do not match other rules will have this rule applied',
        ALREADY_DEFAULT: '"{{name}}" is set as the default expense rule for this entity.',
      },
      Income: {
        MATCHING: 'Which revenue transactions should be recharged?',
        UNMATCHED: 'Make this the default revenue rule?',
        SPECIFIC: 'Recharge specific revenue transactions',
        UNMATCHED_DESC: 'Only revenue transactions which do not match other rules will have this rule applied',
        ALREADY_DEFAULT: '"{{name}}" is set as the default revenue rule for this entity.',
      },
      BalanceSheet: {
        MATCHING: 'Which balance sheet transactions should be recharged?',
        UNMATCHED: 'Make this the default balance sheet rule?',
        SPECIFIC: 'Recharge specific balance sheet transactions',
        UNMATCHED_DESC: 'Only balance sheet transactions which do not match other rules will have this rule applied',
        ALREADY_DEFAULT: '"{{name}}" is set as the default balance sheet rule for this entity.',
      },
      ADD_CONDITION: '+ Add another condition',
    },
  },
};
